import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { BroadcastService } from './services/broadcast.service';
import { BroadcastEffects } from './store/effects';

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature([BroadcastEffects])],
  providers: [BroadcastService],
})
export class BroadcastModule {}
